// extracted by mini-css-extract-plugin
module.exports = {"host":"BaseDatepicker_host__2ANow","label":"BaseDatepicker_label__Bb_h1"};